<template>
  <b-container fluid class="login-page pt-5">
    <b-col cols="12" lg="6" xl="4" offset-lg="3" offset-xl="4">
      <Notification v-bind.sync="notification" />
    </b-col>
    <div class="d-flex justify-content-center">
      <b-card class="mb-2 login-card rounded-0 shadow">
        <b-card-title class="d-flex justify-content-left py-3 fp-message">
          Reset Password
        </b-card-title>
        <b-card-text class="d-flex justify-content-center fp-message">
          Please enter your email address to request a password reset.
        </b-card-text>
        <b-form>
          <b-form-group
            id="username_grp"
            label-for="email_input"
          >
            <b-form-input
              id="email_input"
              type="text"
              placeholder="Email"
              aria-describedby="username_feedback"
              class="mx-auto"
              v-model="formObject.email"
              :state="inputValid.email"
              @keypress.enter="onClickSubmit"
              trim
            />
            <b-form-invalid-feedback id="username_feedback" class="mx-auto fp-message">
              Please provide your email.
            </b-form-invalid-feedback>
          </b-form-group>

          <b-button-toolbar>
            <b-button
              :disabled="isLoadingPage"
              @click="onClickSubmit"
              variant="outline-dark"
              :class="{
                'mr-auto login-btn': googleLoginEnabled,
                'mx-auto login-btn': !googleLoginEnabled,
              }"
            >
              Submit
            </b-button>
          </b-button-toolbar>
        </b-form>
      </b-card>
    </div>
  </b-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Notification from '@/components/Notification';
import AuthService from '@/services/AuthService';


export default {
  name: 'ForgotPassword',
  mixins: [AuthService],
  components: {
    Notification,
  },
  data() {
    return {
      inputValid: {
        email: null,
      },
    };
  },
  computed: {
    googleLoginEnabled() {
      return false;
    },
    ...mapState(['notification']),
    ...mapGetters(['formObject', 'isLoadingPage', 'isLoggedIn']),
  },
  methods: {
    onClickSubmit() {
      const { email } = this.formObject;

      if (!email) {
        return;
      }
      this.startLoadingRequest();
      this.startLoadingPage();
      AuthService.forgotPassword(email)
        .then((result) => {
          const { success, message } = result;
          this.stopLoadingRequest();
          this.stopLoadingPage();
          this.email = '';
          if (!success) {
            return this.setNotification({
              show: true,
              dismissible: true,
              variant: 'danger',
              message: message || 'An error occurred',
              icon: { name: 'exclamation-triangle' },
            });
          }
          return this.setNotification({
            show: true,
            dismissible: true,
            variant: 'success',
            message: message || 'Forgot password request has already been sent.',
            icon: { name: 'check' },
          });
        });
    },
    setError(field) {
      this.inputValid[field] = false;
    },
    resetErrors() {
      Object.keys(this.inputValid).forEach((key) => {
        this.inputValid[key] = null;
      });
    },
    ...mapActions([
      'setFormObject',
      'setNotification',
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.login-page {
  // padding-top: 30px;

  .login-card {
    max-width: 30rem;
    width: 100%;
  }

  .login-btn {
    max-width: 10em;
  }

  .fp-message {
    padding: 0px 30px 10px 30px;
  }

  #email,
  #password {
    &_input,
    &_feedback {
      max-width: 85%;
    }
  }
}
</style>
